<template>
  <div
    class="absolute inset-0 flex items-center justify-center bg-white/80 backdrop-blur-sm"
  >
    <div class="relative">
      <div
        class="w-8 h-8 border-2 border-gray-200 border-t-indigo-600 rounded-full animate-spin"
      ></div>
      <div
        class="absolute inset-0 w-8 h-8 border-2 border-transparent border-r-indigo-400 rounded-full animate-spin animate-reverse"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingSpinner",
};
</script>

<style scoped>
@keyframes reverse-spin {
  to {
    transform: rotate(-360deg);
  }
}

.animate-reverse {
  animation: reverse-spin 1s linear infinite;
}
</style>
